import { render, staticRenderFns } from "./inviteRecords.vue?vue&type=template&id=094999b0&scoped=true&"
import script from "./inviteRecords.vue?vue&type=script&lang=js&"
export * from "./inviteRecords.vue?vue&type=script&lang=js&"
import style0 from "./inviteRecords.vue?vue&type=style&index=0&id=094999b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094999b0",
  null
  
)

export default component.exports